import { get } from '..';

const getChatbotSessions = (
  isDeleted: boolean = false,
  page: number = 1,
) => get(`chatbot-api/chat-sessions?isDeleted=${isDeleted}&page=${page}&limit=10`);

export default getChatbotSessions;
